import {type FlowSetup} from '../types'

export const deserializeSetups = (json: string, terminalNodeId: string): FlowSetup[] => {
  const raw = JSON.parse(json) as FlowSetup[]
  return raw.map((setup) => ({
    ...setup,
    links: setup.links.map((link) => ({
      sourceNodeId: link.sourceNodeId ?? terminalNodeId,
      targetNodeId: link.targetNodeId ?? terminalNodeId
    })),
    positions: setup.positions.map((position) => ({
      ...position,
      nodeId: position.nodeId ?? terminalNodeId
    }))
  }))
}

export const serializeSetups = (setups: FlowSetup[], terminalNodeId: string): string => {
  return JSON.stringify(
    setups.map((setup) => ({
      ...setup,
      links: setup.links.map((link) => ({
        sourceNodeId: link.sourceNodeId === terminalNodeId ? null : link.sourceNodeId,
        targetNodeId: link.targetNodeId === terminalNodeId ? null : link.targetNodeId
      })),
      positions: setup.positions.map((position) => ({
        ...position,
        nodeId: position.nodeId === terminalNodeId ? null : position.nodeId
      }))
    }))
  )
}
